
























































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import moment from 'moment'
import RemuneracaoMedicaApi from '@/Apis/RemuneracaoMedica/Services/RemuneracaoMedicaApi'

@Component({
  filters: {
    number(value: number) {
      if (value == null) return '0'
      return new Intl.NumberFormat('pt-BR').format(value)
    },
  },
})
export default class FinanceiroProducaoDisponivelCalculo extends Vue {
  fontePagadoraId: string | null = null
  prestadorId: string | null = null
  competenciaAnoMes: string | null = null
  operadoraIdFiltro: string | null = null
  menuCompetencia = false

  fontesPagadoras: any[] = []
  prestadores: any[] = []
  itens: any[] = []

  loading = false
  loadingPrestadores = false
  pesquisado = false

  headers = [
    { text: 'Operadora', value: 'nomeOperadora', align: 'left', sortable: true },
    { text: 'Situação', value: 'situacao', align: 'center', sortable: true },
    { text: 'Qtd. Procedimentos', value: 'totalProcedimentos', align: 'center', sortable: true },
  ]

  get filtrosObrigatoriosPreenchidos() {
    return !!this.fontePagadoraId && !!this.prestadorId && !!this.competenciaAnoMes
  }

  get competenciaFormatada() {
    if (!this.competenciaAnoMes) return ''
    return moment(this.competenciaAnoMes).format('MM/YYYY')
  }

  get totalProcedimentos() {
    return this.itensFiltrados.reduce((acc, i) => acc + (i.totalProcedimentos || 0), 0)
  }

  get totalAberto() {
    return this.itensFiltrados
      .filter(i => i.situacao === 'Aberto')
      .reduce((acc, i) => acc + (i.totalProcedimentos || 0), 0)
  }

  get totalCalculado() {
    return this.itensFiltrados
      .filter(i => i.situacao === 'Calculado')
      .reduce((acc, i) => acc + (i.totalProcedimentos || 0), 0)
  }

  get operadorasFiltro() {
    const seen = new Set<string>()
    return this.itens.filter(i => {
      if (!i.operadoraId || seen.has(i.operadoraId)) return false
      seen.add(i.operadoraId)
      return true
    })
  }

  get itensFiltrados() {
    if (!this.operadoraIdFiltro) return this.itens
    return this.itens.filter(i => i.operadoraId === this.operadoraIdFiltro)
  }

  corSituacao(situacao: string) {
    if (situacao === 'Aberto') return { bg: 'teal lighten-4', text: 'teal darken-3' }
    if (situacao === 'Calculado') return { bg: 'orange lighten-4', text: 'orange darken-3' }
    return { bg: 'grey lighten-3', text: 'grey darken-2' }
  }

  async onFontePagadoraChange() {
    this.prestadorId = null
    this.prestadores = []
    this.itens = []
    this.pesquisado = false
    this.operadoraIdFiltro = null

    if (!this.fontePagadoraId) return

    this.loadingPrestadores = true
    try {
      const response = await RemuneracaoMedicaApi.getPrestadores({ limite: 500 })
      if (response.success) {
        this.prestadores = response.data
      }
    } finally {
      this.loadingPrestadores = false
    }
  }

  async pesquisar() {
    if (!this.filtrosObrigatoriosPreenchidos) return

    this.loading = true
    this.itens = []
    this.operadoraIdFiltro = null

    try {
      const competencia = moment(this.competenciaAnoMes).startOf('month').toISOString()
      const response = await RemuneracaoMedicaApi.getProducaoDisponivelResumo({
        fontePagadoraId: this.fontePagadoraId!,
        prestadorId: this.prestadorId!,
        competenciaFaturamentoAnoMes: competencia,
      })

      if (response.success) {
        this.itens = response.data.itens || []
        this.pesquisado = true
      }
    } finally {
      this.loading = false
    }
  }

  async created() {
    try {
      const response = await RemuneracaoMedicaApi.getFontePagadoraAll()
      if (response.success) {
        this.fontesPagadoras = response.data
      }
    } catch (e) {
      // silently fail — layout will show empty select
    }
  }
}
